"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootContentComponent = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const PrivateRoute_1 = require("src/hello_assets/src/components/system/PrivateRoute");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const ErrorBoundaryComponent_1 = require("src/hello_assets/src/components/ui/common/common/errorBoundaryComponent/ErrorBoundaryComponent");
const antd_1 = require("antd");
const HomePage_1 = require("src/hello_assets/src/components/ui/loggedin/content/home/HomePage");
const withProjects_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/withProjects");
const ProjectsPage_1 = require("src/hello_assets/src/components/ui/loggedin/content/projects/ProjectsPage");
const ProjectSwitchComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/ProjectSwitchComponent");
const Profile_1 = require("src/hello_assets/src/components/ui/loggedin/content/profile/Profile");
const ProjectsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/ProjectsProvider");
const ProjectsErrorPage_1 = require("src/hello_assets/src/components/ui/loggedin/content/projects/ProjectsErrorPage");
const Debug_1 = require("src/hello_assets/src/components/ui/loggedin/content/Debug");
const Legal_1 = require("src/hello_assets/src/components/ui/loggedin/content/legal/Legal");
const AdminComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/AdminComponent");
const AdminTestUG_1 = require("src/hello_assets/src/components/ui/loggedin/content/admin/test_ug/AdminTestUG");
// import {TempTest} from "src/hello_assets/src/components/ui/anonymous/tempIdentityTest/TempTest";
const SwitchComponent = () => {
    const projectsContext = (0, ProjectsProvider_1.useProjectsContext)();
    if (projectsContext.projectsState.isError) {
        return React.createElement(ProjectsErrorPage_1.ProjectsErrorPage, { error: projectsContext.projectsState.error });
    }
    // return useMemo(() => {
    return React.createElement(react_router_dom_1.Switch, null,
        React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouting_1.PATH__PROJECT, remounting: true, exactRouteMatchPath: AppRouting_1.PATH__PROJECT, component: ProjectSwitchComponent_1.ProjectSwitchComponent }),
        React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouting_1.PATH__PROJECTS, component: ProjectsPage_1.ProjectsPage }),
        React.createElement(react_router_dom_1.Redirect, { from: "*", to: AppRouting_1.PATH__HOME }));
    // }, [])
};
const SwitchComponentOuter = () => {
    const debugRoute = process.env.NODE_ENV === "development" && React.createElement(PrivateRoute_1.PrivateRoute, { path: "/debug", exact: true, component: Debug_1.Debug });
    // const testRoute = <PrivateRoute path={"/loggedin_testidentityandgovernance"} exact component={TempTest}/>
    return (0, react_1.useMemo)(() => {
        return React.createElement(react_router_dom_1.Switch, null,
            React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouting_1.PATH__HOME, exact: true, component: HomePage_1.HomePage }),
            debugRoute,
            React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouting_1.PATH__PROFILE, component: Profile_1.Profile }),
            React.createElement(SwitchComponent, null));
    }, []);
};
const SwitchComponentWrapped = () => (0, withProjects_1.withProjects)(React.createElement(SwitchComponentOuter, null));
const RootContentComponent = () => {
    return React.createElement(ErrorBoundaryComponent_1.ErrorBoundaryComponent, { childComponentName: "RootContentComponent" },
        React.createElement(antd_1.Row, { style: { flexGrow: 1 } },
            React.createElement(antd_1.Col, { span: 24, className: "pageContentCol" },
                React.createElement(react_router_dom_1.Switch, null,
                    React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouting_1.PATH__LEGAL, component: Legal_1.Legal }),
                    React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouting_1.PATH__ADMIN, component: AdminComponent_1.AdminComponent }),
                    React.createElement(PrivateRoute_1.PrivateRoute, { path: AppRouting_1.PATH__TEST_UG, component: AdminTestUG_1.AdminTestUg }),
                    React.createElement(SwitchComponentWrapped, null)))));
};
exports.RootContentComponent = RootContentComponent;
